"use client";
import { Container, Typography, Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MenuBar from '../components/MenuBar';
import { downloadAPIexamplePython } from "../network";
import FileEnum from '../constants/enums/FileEnum';

interface FAQ {
  question: string;
  answer: string | React.ReactNode;
}

const handleDownloadClick = () => {
    downloadAPIexamplePython(FileEnum.API_EXAMPLE_PYTHON);
  };

function handleContactSupport() {
    window.location.href = 'https://www.planette.ai/contact-support';
  }

const faqs: FAQ[] = [
  {question: "What are the environmental variables that can be queried using the Planette Sura API?", answer: "Currently, we provide the following variables: temperature, precipitation, heating degree days (hdd) and cooling degree days (cdd)."},
  {question: "Where can I find the complete list of country codes that can be queried using the Planette Sura API?", answer: (
    <>
     You can find the complete list of country codes that can be queried using the Planette Sura API <a href='/countrycode' style={{color: "blue"}}>here</a>.
    </>
   )},
   {question: "What is the API endpoint for querying the Planette Sura API?", answer: "The API endpoint for querying the Planette Sura API is: https://backend.planette.ai/api/v1/prediction:fetchByRegion"},
  { question: "How do I query Planette Sura API using Postman?", answer: 
  (
    <>
        <p>To query the Planette API using Postman, send a <strong>GET</strong> request to the following API endpoint:</p>
        <br />

        <code className="avenir-font" style={{ color: '#1F5014', fontSize: 18}}>https://backend.planette.ai/api/v1/prediction:fetchByRegion</code>

        <br /> <br />
        <p>Include the following parameters in the request body:</p>
        <br />
        <ul>
          <li><code className="avenir-font" style={{ color: '#1F5014', fontSize: 18}}>type=SURA</code></li>
          <li><code className="avenir-font" style={{ color: '#1F5014', fontSize: 18}}>variable=temperature</code></li>
          <li><code className="avenir-font" style={{ color: '#1F5014', fontSize: 18}}>country=USA</code></li>
        </ul>
        <br />   
        <p>The API can take variables <code className="avenir-font" style={{ color: '#1F5014', fontSize: 18}}>temperature, precipitation</code>, <code className="avenir-font" style={{ color: '#1F5014', fontSize: 18}}>hdd</code> or <code className="avenir-font" style={{ color: '#1F5014', fontSize: 18}}>cdd</code>. 
        <br /><br />
        Countries can be queried by their full name or using their country codes. For a complete list of country codes, refer <a href="/countrycode" style={{color: "blue"}}>here</a>.</p>
        <br />
        <p>In the request headers, include the <strong>Authorization</strong> field with your personalized API key in the following format:</p>
        <br />
        <code className="avenir-font" style={{ color: '#1F5014', fontSize: 18}}>Authorization: apikey &lt;API_KEY&gt;</code>

        <br /> <br />

        Watch the video below for a step-by-step guide on how to query the Planette API using Postman:

      <iframe src="https://www.loom.com/embed/40662f74f4a144a3b323bb1d25aa2ef1?sid=9fdc19b8-4261-4c5a-a062-e7e77910bdac" 
        frameBorder="0"
        allowFullScreen 
        width="640" 
        height="360"></iframe>
      </>
    
    
    
    ) },
  { question: "How do I query Planette Sura API programmatically?", answer: (

    <>
    <p>To query the Planette API programmatically, include the API endpoint in your code along with your API key.</p>
    <br />

    <p>Click <a href="/planette_api_query.txt" download style={{color: "blue"}}>here</a> to get the Python script for running the API. This saves the code as a text file. Please rename to <strong>planette_api_query.py</strong> before running the script.</p>

    <br />
    
    <p>Modify the parameters in the script based on the data you want to retrieve. For a complete list of countries, refer <a href="/countrycode" style={{color: "blue"}}>here</a>.</p>

    <br />
    
    Watch the video below for a step-by-step guide on how to query the Planette API using Python:

    <iframe src="https://www.loom.com/embed/8e8e3b35e88c456d8dda2992526a7596?sid=da687005-4ecb-4d0f-9c57-2db469cc3e55" 
        frameBorder="0"
        allowFullScreen 
        width="640" 
        height="360"></iframe>
    
    </>

  )
    
    


},
  { question: "Where can I add feature requests?", answer: (
    <>
    <p>
        Please email us at <a href="mailto:support@planette.ai" style={{color: "blue"}}>support@planette.ai</a> or click the <strong>Contact Support</strong> button on the top right.
        </p>
    
    </>

  ) },
];

const FAQItem: React.FC<{ faq: FAQ }> = ({ faq }) => {
  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel-content" id="panel-header">
        <h4 className="avenir-font" style={{ color: '#1F5014', fontSize: 22, marginBottom: '16px' }}>
          {faq.question}
        </h4>
      </AccordionSummary>
      <AccordionDetails>
      <h4 className="avenir-font" style={{ color: 'black', fontSize: 18, marginBottom: '16px' }}>
          {faq.answer}
        </h4>
      </AccordionDetails>
    </Accordion>
  );
};

const FAQPage: React.FC = () => {
  return (
    <div className=" flex flex-col md:flex-row h-screen">
    <MenuBar />
    <div className="flex-1 flex flex-col transparent-background p-4 h-full">
    <div className="flex justify-between items-center mb-4">
          <h4 className="avenir-font title" style={{ color: '#1F5014', marginBottom: '16px' }}>
            Frequently Asked Questions
          </h4>
          <button
            type="button"
            onClick={handleContactSupport}
            style={{
              backgroundColor: '#1F5014',
              color: '#ffffff',
            }}
            className="p-2 border rounded w-36 avenir-font"
          >
            Contact Support
          </button>
    </div>
          {faqs.map((faq, index) => (
        <FAQItem key={index} faq={faq} />
      ))}
    <Container maxWidth="md" sx={{ mt: 4 }}>

    </Container>
    </div>
    </div>
    
  );
};

export default FAQPage;
